__turbopack_context__.v({
  "table-section": "company-listing-table-module-scss-module__C2kZLa__table-section",
  "table-section__count": "company-listing-table-module-scss-module__C2kZLa__table-section__count",
  "table-section__header": "company-listing-table-module-scss-module__C2kZLa__table-section__header",
  "table-section__pagination": "company-listing-table-module-scss-module__C2kZLa__table-section__pagination",
  "table-section__scroll": "company-listing-table-module-scss-module__C2kZLa__table-section__scroll",
  "table-section__sort-icon": "company-listing-table-module-scss-module__C2kZLa__table-section__sort-icon",
  "table-section__sort-icon--descending": "company-listing-table-module-scss-module__C2kZLa__table-section__sort-icon--descending",
  "table-section__table": "company-listing-table-module-scss-module__C2kZLa__table-section__table",
  "table-section__th-content": "company-listing-table-module-scss-module__C2kZLa__table-section__th-content",
  "table-section__title": "company-listing-table-module-scss-module__C2kZLa__table-section__title",
  "table-section__title-wrapper": "company-listing-table-module-scss-module__C2kZLa__table-section__title-wrapper",
});
